import type { CSSProperties } from "react";

export type ThemeAccent =
    | "primary"
    | "muted"
    | "info"
    | "running"
    | "success"
    | "warning"
    | "error"
    | "define"
    | "import"
    | "use"
    | "meta"
    | "content"
    | "render"
    | "for"
    | "explain"
    | "refResolved"
    | "refDefinition"
    | "refScope"
    | "refLoop"
    | "refContent"
    | "refPending"
    | "refRunning"
    | "refError";

const THEME_ACCENT_TO_VARIABLE: Record<ThemeAccent, `--${string}`> = {
    primary: "--color-primary",
    muted: "--color-muted-foreground",
    info: "--color-info",
    running: "--status-running",
    success: "--status-success",
    warning: "--status-warning",
    error: "--status-error",
    define: "--cm-define-accent",
    import: "--cm-import-accent",
    use: "--cm-use-accent",
    meta: "--cm-meta-accent",
    content: "--cm-content-accent",
    render: "--cm-render-accent",
    for: "--cm-for-accent",
    explain: "--cm-explain-accent",
    refResolved: "--cm-ref-resolved",
    refDefinition: "--cm-ref-definition",
    refScope: "--cm-ref-scope",
    refLoop: "--cm-ref-loop",
    refContent: "--cm-ref-content",
    refPending: "--cm-ref-pending",
    refRunning: "--cm-ref-running",
    refError: "--cm-ref-error",
};

export function getThemeAccentValue(accent: ThemeAccent): string {
    return `var(${THEME_ACCENT_TO_VARIABLE[accent]})`;
}

export function getThemeAccentStyle(accent: ThemeAccent): CSSProperties {
    return {
        "--theme-accent": getThemeAccentValue(accent),
    } as CSSProperties;
}
